import { RouteObject, Navigate } from "react-router-dom";
import LoginPage from "@/pages/login/page";
import DashboardLayout from "@/components/feature/DashboardLayout";
import DashboardPage from "@/pages/dashboard/page";
import VelilerPage from "@/pages/veliler/page";
import KampanyalarPage from "@/pages/kampanyalar/page";
import YeniKampanyaPage from "@/pages/kampanyalar/yeni/page";
import HatirlatmalarPage from "@/pages/hatirlatmalar/page";
import ReferansPage from "@/pages/referans/page";
import OdemePage from "@/pages/odeme/page";
import TaahhutPage from "@/pages/taahhut/page";
import SablonlarPage from "@/pages/sablonlar/page";
import GonderimPage from "@/pages/gonderim/page";
import RaporlarPage from "@/pages/raporlar/page";
import AyarlarPage from "@/pages/ayarlar/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        path: "dashboard",
        element: <DashboardPage />,
      },
      {
        path: "veliler",
        element: <VelilerPage />,
      },
      {
        path: "kampanyalar",
        element: <KampanyalarPage />,
      },
      {
        path: "kampanyalar/yeni",
        element: <YeniKampanyaPage />,
      },
      {
        path: "hatirlatmalar",
        element: <HatirlatmalarPage />,
      },
      {
        path: "referans",
        element: <ReferansPage />,
      },
      {
        path: "odeme",
        element: <OdemePage />,
      },
      {
        path: "taahhut",
        element: <TaahhutPage />,
      },
      {
        path: "sablonlar",
        element: <SablonlarPage />,
      },
      {
        path: "gonderim",
        element: <GonderimPage />,
      },
      {
        path: "raporlar",
        element: <RaporlarPage />,
      },
      {
        path: "ayarlar",
        element: <AyarlarPage />,
      },
      {
        path: "*",
        element: <Navigate to="/dashboard" replace />,
      },
    ],
  },
];

export default routes;